export class EmailAlreadyVerifiedError extends Error {
  constructor(message) {
    super(message);
  }
}